import AccountTreeIcon from '@mui/icons-material/AccountTree';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import BugReportIcon from '@mui/icons-material/BugReport';
import CloudIcon from '@mui/icons-material/Cloud';
import ComputerIcon from '@mui/icons-material/Computer';
import DashboardIcon from '@mui/icons-material/Dashboard';
import DescriptionIcon from '@mui/icons-material/Description';
import FlashOnIcon from '@mui/icons-material/FlashOn';
import GavelIcon from '@mui/icons-material/Gavel';
import GroupIcon from '@mui/icons-material/Group';
import PolicyIcon from '@mui/icons-material/Policy';
import SearchIcon from '@mui/icons-material/Search';
import SecurityIcon from '@mui/icons-material/Security';
import TrackChangesIcon from '@mui/icons-material/TrackChanges';
import type { CSSProperties, FC, ReactNode } from 'react';

export type SecurityNavIconColors = {
  active: string;
  inactive: string;
};

const SECURITY_NAV_ICON_COMPONENTS: Record<string, FC<{ style?: CSSProperties }>> = {
  'security-operations-center': SecurityIcon,
  'reseller-dashboard': DashboardIcon,
  'sub-org-dashboard': DashboardIcon,
  clients: GroupIcon,
  endpoints: ComputerIcon,
  'configuration-assessment': AssignmentTurnedInIcon,
  'malware-detection': BugReportIcon,
  'automated-response': FlashOnIcon,
  'file-integrity-monitoring': DescriptionIcon,
  'threat-hunting': SearchIcon,
  'vulnerability-detection': PolicyIcon,
  'mitre-attck': TrackChangesIcon,
  'pci-dss': GavelIcon,
  gdpr: PolicyIcon,
  hipaa: SecurityIcon,
  'nist-800-53': AccountTreeIcon,
  tsc: AssignmentTurnedInIcon,
  'google-cloud': CloudIcon,
  'office-365': CloudIcon,
};

const resolveIconColor = (active: boolean | undefined, colors: SecurityNavIconColors): string =>
  active ? colors.active : colors.inactive;

const getNavIconStyle = (
  active: boolean | undefined,
  colors: SecurityNavIconColors
): CSSProperties => ({
  fontSize: 18,
  color: resolveIconColor(active, colors),
  flexShrink: 0,
});

export const renderSecurityNavIcon = (
  id: string,
  active: boolean | undefined,
  colors: SecurityNavIconColors
): ReactNode => {
  const Icon = SECURITY_NAV_ICON_COMPONENTS[id] ?? SecurityIcon;
  return <Icon style={getNavIconStyle(active, colors)} />;
};

/** Show a divider after this nav item id (separates primary EDR links from feature pages). */
export const SECURITY_NAV_DIVIDER_AFTER = new Set(['endpoints']);
